module.exports = __webpack_public_path__ + "img/photosession_1_11.8d145d46.jpg";